// Constants for better maintainability
export const PROFILE_MESSAGES = {
  NO_DEGREES: 'No degrees for this profile yet',
  NO_ADDRESSES: 'No physical addresses for this profile yet',
  NO_PHONES: 'No phone numbers for this profile yet',
};
